import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CompleteProfileModal from '../../../components/modals/CompleteProfileModal';
import {
  carNote,
  carPerson,
  completeTriangleLeftFooter,
  completeTrianglePost,
  filterImage,
  keyHome,
  orderBuyer,
  orderOwner,
  triangleLeftFooter,
  trianglepost,
  vectorLeft,
  vectorRight,
} from '../../../assets/icons';
import {
  AddOrder,
  ChooseCar,
  DashboardCard,
  Filter,
  GeneralSwiper,
  ServicesCard,
  ButtonIcon,
  MDashboardCard,
  HomeOffers,
  WhyMshrai,
  Button,
} from '../../../components';
import { languageAr, userRole, userToken } from '../../../helpers/helper';
import { getMediators } from '../../../services/apis/home';
import { useContext } from 'react';
import { UserContext } from '../../../context/UserContext';
import { Carousel } from 'flowbite-react';

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [mediators, setMediators] = useState([]);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState('');
  const { userData } = useContext(UserContext);
  const [postsBuyers, setPostsBuyers] = useState([
    { id: 1, src: filterImage, text: t('home.filter.getCar'), bg: '#D7E2FF' },
    { id: 2, src: carNote, text: t('home.filter.carNote'), bg: '#C7F1EF' },
    { id: 3, src: carPerson, text: t('home.filter.carPerson'), bg: '#91A7E2' },
  ]);

  const [postsMediators, setPostsMediators] = useState([
    {
      id: 1,
      src: keyHome,
      text: t('home.filter.addOfferToBuyers'),
      bg: '#DCECFD',
    },
    { id: 2, src: carNote, text: t('home.filter.carNoteM'), bg: '#C7F1EF' },
    { id: 3, src: carPerson, text: t('home.filter.carPersonM'), bg: '#91A7E2' },
  ]);

  useEffect(() => {
    if (userToken && userRole == 2) {
      getAllMediators();
    }
  }, []);

  const getAllMediators = async () => {
    const response = await getMediators('');
    let arr = [];
    response.data.items.forEach((element) => {
      let obj = {
        name: element.mediatorInfo.fullName,
        car: false,
        stars: element.mediatorInfo.medAvgRating,
        img: element.mediatorInfo.profileImg,
        id: element.mediatorInfo.id,
      };
      arr.push(obj);
    });
    setMediators(arr);
  };

  return (
    <div>
      <div className="bg-white">
        {userRole == 3 && userToken ? (
          <div
            className="h-[400px] sm:h-[400px] xl:h-[400px] 2xl:h-[400px] carousel-container w-[90%] mr-auto ml-auto"
            style={{ direction: 'ltr' }}
          >
            <Carousel>
              {postsMediators.map((item, index) => (
                <div
                  key={index}
                  style={{
                    direction: languageAr ? 'rtl' : 'ltr',
                    backgroundColor: item.bg,
                  }}
                  className="p-5 h-[100%] relative flex justify-center items-center"
                >
                  <div className="grid 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1">
                    <div className="relative flex justify-center ">
                      <div
                        className={`text-[#3E0292] font-bold text-[38px] flex items-center justify-center ${languageAr ? 'text-right' : 'text-left'} drop-shadow-lg`}
                      >
                        {item.text}
                      </div>
                      <img
                        src={languageAr ? vectorLeft : vectorRight}
                        className={
                          languageAr
                            ? 'vectorLeft absolute left-0 bottom-0 z-10'
                            : 'vectorRight absolute right-0 bottom-0 z-10'
                        }
                      />
                      <img
                        src={languageAr ? vectorRight : vectorLeft}
                        className={
                          languageAr
                            ? 'vectorRight absolute right-0 top-0 z-10'
                            : 'vectorLeft absolute left-0 top-0 z-10'
                        }
                      />
                    </div>
                    <div className="flex justify-center items-center">
                      <img
                        src={item.src}
                        alt={item.text}
                        className=" object-content"
                      />
                    </div>

                    <img
                      src={languageAr ? trianglepost : triangleLeftFooter}
                      className={
                        languageAr
                          ? 'absolute right-0 bottom-0'
                          : 'absolute left-0 bottom-0'
                      }
                    />
                    <img
                      src={
                        languageAr
                          ? completeTrianglePost
                          : completeTriangleLeftFooter
                      }
                      className={
                        languageAr
                          ? 'absolute right-0.5 bottom-0'
                          : 'absolute left-0.5 bottom-0'
                      }
                    />
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        ) : (
          <div
            className="h-[400px] sm:h-[400px] xl:h-[400px] 2xl:h-[400px] carousel-container w-[90%] mr-auto ml-auto"
            style={{ direction: 'ltr' }}
          >
            <Carousel>
              {postsBuyers.map((item, index) => (
                <div
                  key={index}
                  style={{
                    direction: languageAr ? 'rtl' : 'ltr',
                    backgroundColor: item.bg,
                  }}
                  className="p-5 h-[100%] relative flex justify-center items-center"
                >
                  <div className="grid 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1">
                    <div className="relative flex justify-center">
                      <div
                        className={`text-[#3E0292] font-bold text-[38px] flex items-center justify-center ${languageAr ? 'text-right' : 'text-left'} drop-shadow-lg`}
                      >
                        {item.text}
                      </div>
                      <img
                        src={languageAr ? vectorLeft : vectorRight}
                        className={
                          languageAr
                            ? 'vectorLeft absolute left-0 bottom-0 z-10'
                            : 'vectorRight absolute right-0 bottom-0 z-10'
                        }
                      />
                      <img
                        src={languageAr ? vectorRight : vectorLeft}
                        className={
                          languageAr
                            ? 'vectorRight absolute right-0 top-0 z-10'
                            : 'vectorLeft absolute left-0 top-0 z-10'
                        }
                      />
                    </div>
                    <div className="flex justify-center items-center">
                      <img
                        src={item.src}
                        alt={item.text}
                        className=" object-content"
                      />
                    </div>

                    <img
                      src={languageAr ? trianglepost : triangleLeftFooter}
                      className={
                        languageAr
                          ? 'absolute right-0 bottom-0'
                          : 'absolute left-0 bottom-0'
                      }
                    />
                    <img
                      src={
                        languageAr
                          ? completeTrianglePost
                          : completeTriangleLeftFooter
                      }
                      className={
                        languageAr
                          ? 'absolute right-0.5 bottom-0'
                          : 'absolute left-0.5 bottom-0'
                      }
                    />
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        )}
        {!userToken || userRole == 3 ? null : (
          <div className="flex items-center justify-center bg-[#EBF0FF] w-[100%] mt-5 p-4">
            <Filter />
          </div>
        )}
        {userRole == 2 && (
          <div className="grid grid-cols-2 max600:grid-cols-1 sm:grid-cols-2 my-10 w-[80%] mr-auto ml-auto gap-x-3">
            <ButtonIcon
              titleClass={'text-[15px] font-700 text-[#ffffff]'}
              onClick={() => {
                if (!userToken) {
                  navigate('/login');
                } else if (!userData?.fullName) {
                  setShowProfileModal(true);
                  setPendingNavigation('/car-owner/add');
                } else {
                  navigate('/car-owner/add');
                }
              }}
              className={'shadow-lg bg-[#3E0292] border-[#3E0292]'}
              dark={false}
              title={t('home.filter.addOrderCarOwner')}
              icon={orderOwner}
            />
            <ButtonIcon
              titleClass={'text-[15px] font-700 text-[#ffffff]'}
              onClick={() => {
                if (!userToken) {
                  navigate('/login');
                } else if (!userData?.fullName) {
                  setShowProfileModal(true);
                  setPendingNavigation('/orders/add');
                } else {
                  navigate('/orders/add');
                }
              }}
              dark={false}
              className="bg-[#00CEBC] shadow-lg border-[#00CEBC] max600:mt-3 max800:mt-3"
              title={t('home.filter.addOrderBuyer')}
              icon={orderBuyer}
            />
          </div>
        )}
      </div>

      {!userToken || userRole == 3 ? <WhyMshrai /> : null}

      {!userToken ? (
        <>
          {/* <CarsType />
          <CarsMostBuyer />
          <RegisterMobile /> */}
          <ChooseCar />
        </>
      ) : (
        <>{userRole == 3 ? <MDashboardCard /> : <DashboardCard />}</>
      )}
      {userRole == 3 && userToken && (
        <div className="my-10 bg-[#C7F1EF] rounded-[15px] w-[90%] mr-auto ml-auto p-5">
          <div className="flex flex-row items-center justify-between p-5">
            <div className="text-[30px] text-[#444444] underline mb-5 font-700">
              {t('home.clients.lastOffers')}
            </div>
            <Button
              title={t('home.clients.allOffers')}
              dark={true}
              onClick={() => navigate('/offers')}
            />
          </div>
          <HomeOffers />
        </div>
      )}
      {userRole == 2 && <AddOrder />}

      {!userToken ? (
        <div className="mt-16">
          {/* <div className="text-[40px] text-[#444444] underline text-center mb-5 font-700">
            {t('home.clients.title')}
          </div>
          <GeneralSwiper users={users} /> */}
        </div>
      ) : (
        <>
          {userRole == 3 ? null : (
            <div className="mt-16">
              <div className="text-[40px] text-[#444444] underline text-center mb-5 font-700">
                {t('home.clients.titleMediators')}
              </div>
              <GeneralSwiper users={mediators} />
            </div>
          )}
        </>
      )}

      {/* {!userToken ? <DownloadApp /> : null} */}
      <ServicesCard />
      <CompleteProfileModal
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
        onConfirm={() => {
          setShowProfileModal(false);
          navigate('/profile');
        }}
      />
    </div>
  );
};

export default Home;
